import * as React from 'react';

interface SocialSvgProps {
  className?: string;
}

export const Facebook: React.FC<SocialSvgProps> = ({ className }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-platform="facebook"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M13.5 8.5h2.25l.25-3H13.5V4c0-.69.56-1.25 1.25-1.25h1.5V0h-2.25C12.07 0 10.5 1.57 10.5 3.5v2H8v3h2.5V24h3V8.5z" />
  </svg>
);
